import { render, staticRenderFns } from "./BookedAirfare.vue?vue&type=template&id=86df7ed4"
import script from "./BookedAirfare.vue?vue&type=script&lang=js"
export * from "./BookedAirfare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports